import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import { notification, Button, Form } from "antd";
import queryString from "query-string";
import { config } from "../../settings/config";

import PanelView from "../template/panel";

import AppContext from "../../AppContext";
import { withRouter } from "react-router-dom";

class Authorize extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  componentDidMount() {
    if (!config.sso_enabled) {
      this.context.navigate("/signin");
    }
    this.signal = axios.CancelToken.source();
    let q_params = queryString.parse(this.props.location.search);
    if (q_params?.code && !this.context.isAuthenticated) {
      this.setState({ isLoading: true });
      this.handleAuthorize(q_params?.code);
    } else {
      this.checkForSSOError();
    }
  }

  componentWillUnmount() {
    this.signal.cancel();
  }

  handleAuthorize = code => {
    const params = new URLSearchParams();
    params.append("grant_type", config?.sso_config?.grant_type);
    params.append("client_id", config?.sso_config?.client_id);
    params.append("redirect_uri", config?.sso_config?.redirect_uri);
    params.append("code", code);
    params.append("code_verifier", localStorage.getItem("fef.auth.verifier"));
    localStorage.removeItem("fef.auth.verifier");
    axios
      .post(`https://${config?.sso_config?.auth_url}/oauth2/token`, params, { cancelToken: this.signal.token })
      .then(async response => {
        let tokens = response.data;
        sessionStorage.clear();
        if (await this.context.authorize_user(tokens)) {
          this.context.trackLyticsEvent("Authentication", "Password Authentication Successful");
          await this.context.updateUserStatus();
          setTimeout(() => this.context.trackLyticsPage(window.location.pathname), 2);
          this.context.navigate(this.context.defaultPage);
        } else {
          this.context.trackLyticsEvent("Authentication", "Password Authentication Failed");
          notification.error({
            message: this.props.intl.formatMessage({ id: "Authorization Error" }),
          });
          this.setState({ isLoading: false });
          this.context.navigate("/authorize");
        }
      })
      .catch(error => {
        this.context.trackLyticsEvent("Authentication", "Password Authentication Failed");
        if (error) {
          notification.error({
            message: this.props.intl.formatMessage({ id: error.message }),
          });
        }
        this.context.navigate("/authorize");
      });
  };

  checkSkip = () => {
    if (this.context.isAuthenticated) {
      this.context.navigate("/");
      return;
    }
  };

  handleSSOStart = async e => {
    // not used so commenting out for now and will remove later if there are no issues
    //let auth = localStorage.getItem("fef.auth.verifier");
    if (this.context.isAuthenticated) {
      this.context.navigate("/");
      return;
    }
    e.preventDefault();

    let verifier = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(128)))).replace(
      /\/|\+|=/g,
      x => ({ "/": "_", "+": "-", "=": "" }[x])
    );
    let hash = await crypto.subtle.digest("SHA-256", new Uint8Array([...verifier].map(e => e.charCodeAt(0))));
    let challenge = btoa(String.fromCharCode(...new Uint8Array(hash))).replace(
      /\/|\+|=/g,
      x => ({ "/": "_", "+": "-", "=": "" }[x])
    );

    localStorage.setItem("fef.auth.verifier", verifier);

    const sso_url = `https://${config?.sso_config?.auth_url}/oauth2/authorize?identity_provider=${config?.sso_config?.identity_provider}&redirect_uri=${config?.sso_config?.redirect_uri}&response_type=CODE&client_id=${config?.sso_config?.client_id}&scope=${config?.sso_config?.scope}&code_challenge_method=S256&code_challenge=${challenge}`;
    window.location.href = sso_url;
  };

  checkForSSOError = () => {
    let q_params = queryString.parse(this.props.location.search);
    let error = q_params.error_description ?? null;
    if (error) {
      this.context.trackLyticsEvent("Authentication", "Password Authentication Error");
      return notification.error({
        message: this.props.intl.formatMessage({
          id: "There was an error logging in. If the issue persists, please contact your system administrator.",
        }),
      });
    }
  };

  render() {
    this.checkSkip();
    // not used so commenting out for now and will remove later if there are no issues
    //const sso_url = `https://${config?.sso_config?.auth_url}/oauth2/authorize?identity_provider=${config?.sso_config?.identity_provider}&redirect_uri=${config?.sso_config?.redirect_uri}&response_type=CODE&client_id=${config?.sso_config?.client_id}&scope=${config?.sso_config?.scope}`;
    return (
      <PanelView>
        <Form layout="vertical">
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              shape="round"
              style={{ width: 10 + "em" }}
              loading={this.state.isLoading || this.state.isAuthenticating}
              onClick={this.handleSSOStart}
            >
              {this.state.isLoading ? (
                <>
                  <FormattedMessage id="Logging in" />
                  ...
                </>
              ) : (
                <FormattedMessage id="SSO Login" />
              )}
            </Button>
          </Form.Item>
        </Form>
        <Link to={"/signin"} style={{ textAlign: "center" }}>
          <Button type="link">Sign in</Button>
        </Link>
      </PanelView>
    );
  }
}

export default withRouter(injectIntl(Authorize));
